import { createFileRoute } from '@tanstack/react-router';

import { CommitsSettingsPage, linkOutcomeSearch } from '@/features/identity';
import { useWorkspaceList } from '@/features/workspaces';

export const Route = createFileRoute('/settings/commits')({
  // The forge's sign-in returns here with `?linked=` or `?link_error=` (spec
  // 161); the page says it once and then takes it out of the address.
  validateSearch: linkOutcomeSearch,
  component: CommitsSettingsRoute,
});

export function CommitsSettingsRoute() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  // Where each host is required is said by name (spec 163). Read here: the
  // workspaces feature already depends on identity, not the other way round.
  const workspaces = useWorkspaceList({ limit: 200 });

  return (
    <CommitsSettingsPage
      search={search}
      workspaces={workspaces.data?.items}
      onOutcomeRead={() => {
        void navigate({ search: {}, hash: 'linked-accounts', replace: true });
      }}
    />
  );
}
